export default __webpack_public_path__ + "static/media/vigot-screenshot-03.a6d33411.png";